export const faqData = [
  {
    id: 1,
    question: "How is the EMI for ICICI Bank Personal Loan calculated?",
    answer:
      "The EMI is calculated using the loan amount, interest rate, and loan tenure. The EMI formula used is:",
    answerTwo:
      "EMI=P×r×(1+r)n(1+r)n−1EMI = \frac{P \times r \times (1 + r)^n}{(1 + r)^n - 1} ",
    answerThree: "Where: ",
    answerList: [
      {
        info: "P = Loan amount",
      },
      {
        info: "r = Monthly interest rate (annual rate divided by 12)",
      },
      {
        info: "n = Loan tenure (in months)",
      },
    ],
  },
  {
    id: 2,
    question: "What is the processing fee for ICICI Bank Personal Loan?",
    answer:
      "ICICI Bank charges a processing fee of 1% of the loan amount (with a maximum of ₹2,000). This fee is deducted upfront from the loan amount.",
  },
  {
    id: 3,
    question: "Can I change my loan tenure after approval?",
    answer:
      "Once the loan is approved and disbursed, the loan tenure generally cannot be changed. However, you can make prepayments to reduce the outstanding balance and the EMI amount.",
  },
  {
    id: 4,
    question: "How can I apply for an ICICI Bank Personal Loan?",
    answer:
      "You can apply for a personal loan online through the ICICI Bank website or mobile app. The process is quick and can be completed without visiting a branch.",
  },
  {
    id: 5,
    question: "What factors impact my ICICI Bank Personal Loan EMI?",
    answer:
      "Your EMI is affected by the loan amount, interest rate, loan tenure, and processing fees. A higher loan amount or interest rate will result in higher EMIs, while a longer tenure will result in lower EMIs but higher interest.",
  },
  {
    id: 6,
    question:
      "Is there any penalty for prepayment of ICICI Bank Personal Loan?",
    answer:
      "ICICI Bank does not charge a penalty for prepayment of the loan. In fact, making a prepayment can reduce the outstanding loan balance and help lower your future EMI.",
  },
];
